class mapping {
  static requiredProperties<
    sourcePropertiesT,
    requiredPropertiesT,
    sourcePropertyT extends keyof sourcePropertiesT,
    requiredPropertyT extends keyof requiredPropertiesT
  >
    (source: sourcePropertiesT, map: Map<sourcePropertyT, requiredPropertyT>): requiredPropertiesT {

    let params = {
    } as any;

    for (let [sourceProperty, requiredProperty] of map.entries()) {
      params[requiredProperty] = source[sourceProperty];
    }

    return params;

  }
}
export default mapping;


// WEBPACK FOOTER //
// ./src/ts/Tool/mapping.ts